import SubscriptionStatusModel from '@models/account/SubscriptionStatusModel';
import doc                     from '@widesk-core/decorators/doc';
import model                   from '@widesk-core/decorators/model';
import AccountServiceModel     from '@/models/AccountServiceModel';
import TimestampAble           from '@widesk-core/models/traits/TimestampAble';
import Blamable                from '@/models/traits/Blamable';

@model.urnResource('subscription')
@doc.path('/subscriptions/{?id}')
export default class SubscriptionModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'accountSubscriptions': id;
		'isPublic': boolean;
		'subscriptionConfigs': id;
		'subscriptionStatus': id;
		'subscriptionStatus.reference': Account_SubscriptionStatusReference;
		'subscriptionStatusHistories': id;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
		'position': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Account_SubscriptionReference;

	// Pilotent le catalogue public du site vitrine : /subscriptions/public ne renvoie que
	// les offres `isPublic` et actives, triées par `position`.
	@doc.boolean declare isPublic: boolean;
	@doc.number declare position: number;
	@doc.model(SubscriptionStatusModel) declare subscriptionStatus: SubscriptionStatusModel;
}